import { APPS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const appsRoute = createGlobalRoute({
  exact: true,
  name: 'apps',
  path: APPS_PATH,
  layout: 'home',
});
